// Clean Mobile Navigation Script
$(document).ready(function () {
    console.log('Clean scripts loaded - setting up mobile navigation');

    // Check if elements exist
    console.log('Nav toggle exists:', $('#wsnavtoggle').length);
    console.log('Menu container exists:', $('.wsmenucontainer').length);

    // Mobile navigation toggle
    $(document).on('click', '#wsnavtoggle', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Nav toggle clicked');
        $('.wsmenucontainer').toggleClass('wsoffcanvasopener');
        console.log('Menu container classes:', $('.wsmenucontainer').attr('class'));
        return false;
    });

    // Close menu when clicking overlay
    $(document).on('click', '.overlapblackbg', function () {
        console.log('Overlay clicked - closing menu');
        $('.wsmenucontainer').removeClass('wsoffcanvasopener');
    });
});

// Original mobile menu functionality
$(function () {
    $('#wsnavtoggle').click(function () {
        $('.wsmenucontainer').toggleClass('wsoffcanvasopener');
    });

    $('.overlapblackbg').click(function () {
        $('.wsmenucontainer').removeClass('wsoffcanvasopener');
    });

    if (jQuery(window).width() <= 800) {
        if ($('#scrollerAttempt').parent().is('div')) {
            $('#scrollerAttempt').unwrap();
        }
    } else {
        if (!$('#scrollerAttempt').parent().is('div')) {
            $('#scrollerAttempt').wrap("<div></div>");
            $('#scrollerAttempt').css('display', 'block');
        }
    }

    $(window).resize(function () {
        var width = $(window).width();
        if (width <= 800) {
            if ($('#scrollerAttempt').parent().is('div')) {
                $('#scrollerAttempt').unwrap();
            }
        } else {
            if (!$('#scrollerAttempt').parent().is('div')) {
                $('#scrollerAttempt').wrap("<div></div>");
                $('#scrollerAttempt').css('display', 'block');
            }
        }
    });

    $('.wsmenu-list> li').has('.wsmenu-submenu').prepend('<span class="wsmenu-click"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
    $('.wsmenu-list > li').has('.megamenu').prepend('<span class="wsmenu-click"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
    $('.wsmenu-click').click(function () {
        $(this).toggleClass('ws-activearrow').parent().siblings().children().removeClass('ws-activearrow');
        $(".wsmenu-submenu, .megamenu").not($(this).siblings('.wsmenu-submenu, .megamenu')).slideUp('slow');
        $(this).siblings('.wsmenu-submenu').slideToggle('slow');
        $(this).siblings('.megamenu').slideToggle('slow');
    });


    $('.wsmenu-special-menu').click(function (e) {
        var width = $(window).width();

        if (width <= 800) {
            e.preventDefault();

            $(this).siblings('.wsmenu-click').toggleClass('ws-activearrow').parent().siblings().children().removeClass('ws-activearrow');
            $(".wsmenu-submenu, .megamenu").not($(this).siblings('.wsmenu-submenu, .megamenu')).slideUp('slow');
            $(this).siblings('.wsmenu-click').siblings('.wsmenu-submenu').slideToggle('slow');
            $(this).siblings('.wsmenu-click').siblings('.megamenu').slideToggle('slow');
        }
    });

    $('.wsmenu-list > li > ul > li').has('.wsmenu-submenu-sub').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
    $('.wsmenu-list > li > ul > li > ul > li').has('.wsmenu-submenu-sub-sub').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
    $('.wsmenu-click02').click(function () {
        $(this).children('.wsmenu-arrow').toggleClass('wsmenu-rotate');
        $(this).siblings('.wsmenu-submenu-sub').slideToggle('slow');
        $(this).siblings('.wsmenu-submenu-sub-sub').slideToggle('slow');
    });

    $('.wsmenu-special-menu2').click(function (e) {
        var width = $(window).width();

        if (width <= 800) {
            e.preventDefault();
            $(this).siblings('.wsmenu-click02').children('.wsmenu-arrow').toggleClass('wsmenu-rotate');
            $(this).siblings('.wsmenu-click02').siblings('.wsmenu-submenu-sub').slideToggle('slow');
            $(this).siblings('.wsmenu-click02').siblings('.wsmenu-submenu-sub-sub').slideToggle('slow');
        }
    });

});

$(function () {
    $('.wsmenu-sub-list > li').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
    $('.wsmenu-sub-list > li > ul > li').has('.level').prepend('<span class="wsmenu-click02"><i class="wsmenu-arrow fa fa-angle-down"></i></span>');
    $('.wsmenu-click02').click(function () {
        $(this).children('.wsmenu-arrow').toggleClass('wsmenu-rotate');
        $(this).siblings('.wsmenu-sub-list ul').slideToggle('slow');
    });
    $(window).resize(function () {
        if ($(window).width() > 767) {
            $('.wsmenu-sub-list ul').slideDown();
        }
    });
});

// jQuery Cookie fallback
if (typeof $.cookie === 'undefined') {
    $.cookie = function (name, value, options) {
        if (typeof value === 'undefined') {
            // Get cookie
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        } else {
            // Set cookie
            if (value === null) {
                value = '';
                options = {expires: -1};
            }
            let expires = '';
            if (options && options.expires) {
                const date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + value + expires + '; path=/';
        }
    };
} 